import React from 'react';
import { Button, css, DNA } from '@dna/react';
import { ButtonProps } from "@dna/react-types";
export function FlatButton(props: ButtonProps) {
    return (<Button {...props} UNSAFE_className={css({
        borderRadius: `${0} !important`,
        width: props.css?.width,
        margin: props.css?.margin
    })}>
        {props.children}
    </Button>)
}




export function FlatPaginationButton(props: ButtonProps) {
    return (<Button {...props} UNSAFE_className={css({
        borderRadius: `${0} !important`,
        width: props.css?.width,
        height: "40px",
        borderColor: `${DNA.tokens.color.gray["300"]} !important`
    })}>
        {props.children}
    </Button>)
}